export const financeColors = {
  surface: '#ffffff',
  surfaceAlt: '#f8fafc',
  surfaceInfo: '#f8fbff',
  border: '#e5e7eb',
  borderStrong: '#dbe3f1',
  text: '#111827',
  textMuted: '#6b7280',
  textSoft: '#4b5563',
  successBg: '#edfdf3',
  successBorder: '#b7ebc6',
  warningBg: '#fff9e8',
  warningBorder: '#fde68a',
  dangerBg: '#fff1f2',
  dangerBorder: '#fecaca',
  infoBg: '#eff6ff',
  infoBorder: '#bfdbfe',
  primary: '#0f766e',
} as const

export const financeRadius = {
  sm: '12px',
  md: '16px',
  lg: '18px',
  pill: '999px',
} as const

export const financeSpacing = {
  xs: '8px',
  sm: '12px',
  md: '16px',
  lg: '20px',
  xl: '24px',
} as const
